'use strict';

const Enum = require('./enum');

/**
 * Defines identifiers for partners
 *
 * @enum
 * @readonly
 */
exports.Partners = Object.create(Enum, {
  AIRBNB: {
    value: 'airbnb',
    enumerable: true,
  },
  NEST: {
    value: 'nest',
    enumerable: true,
  },
  COMCAST: {
    value: 'comcast',
    enumerable: true,
  },
  HMAC_KEY: {
    value: 'ba1440fe-0690-4688-ab3e-e32cee121cbf',
    enumerable: true,
  },
});

/**
 * Defines events that apply to
 * partner-related operations.
 *
 * @enum
 * @readonly
 */
exports.PartnerEvents = Object.create(Enum, {
  CONNECT: {
    value: 'connect',
    enumerable: true,
  },
  DISCONNECT: {
    value: 'disconnect',
    enumerable: true,
  },
});

/**
 * Defines partner types.  Every partner has one type.
 *
 * @enum
 * @readonly
 */
exports.PartnerTypes = Object.create(Enum, {
  WORKS_WITH: {
    value: 'works with',
    enumerable: true,
  },
  AUGUST_ACCESS: {
    value: 'august access',
    enumerable: true,
  },
});

/**
 * This is the order we want to display the partner tags in the client apps.
 */
exports.PartnerTags = ['featured', 'smart home', 'delivery', 'home services', 'rentals', 'pet care'];

exports.PARTNER_PLATFORM_IOS = 'ios';
exports.PARTNER_PLATFORM_ANDROID = 'android';
exports.PARTNER_ID_NEST = '579a5dfaf1a1227b4049a2b1';
exports.PARTNER_ID_AIRBNB = '579a5dfaf1a1227b4049a2af';
exports.PARTNER_ID_KEYBYAMAZON = '5f31d6dd3e72f5000f7fcad2';
exports.PARTNER_ID_HUE = '5f19ca2a05fc94001037a79d'; // Mongo object ID from db.partners for Hue partner
exports.PARTNER_ID_HUE_YALE = 'HUE_YALE_PARTNER_ID'; // There is one partner Hue, but 2 ways to oauth, yale and august.

exports.AirbnbListingAccessTypes = {
  APP_AND_KEYPAD_ACCESS: { value: 1, enumerable: true },
  KEYPAD_ACCESS_ONLY: { value: 2, enumerable: true },
  APP_ACCESS_ONLY: { value: 3, enumerable: true },
};
